import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { ElearningCategoryFilterItems } from 'modules/trainingLibrary/Elearning/types'
import { getTrainingLibraryOverview } from 'modules/trainingLibrary/TrainingLibrary/api/trainingLibraryService'
import { TrainingLibraryData, TrainingLibraryState } from './types'

const initialState: TrainingLibraryState = {
  trainingLibraryData: {},
}

const trainingLibrarySlice = createSlice({
  name: 'trainingLibrary',
  initialState,
  reducers: {
    trainingLibraryDataLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<TrainingLibraryData>>
    ) {
      state.trainingLibraryData = action.payload
    },
    clearTrainingLibrary(state) {
      state.trainingLibraryData = initialState.trainingLibraryData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { trainingLibraryDataLoaded, clearTrainingLibrary } = trainingLibrarySlice.actions

export { clearTrainingLibrary }

export default trainingLibrarySlice.reducer

export const getTrainingLibraryData = (externalFilters: ElearningCategoryFilterItems) => {
  return createApiAction({
    apiCalls: {
      overview: () => getTrainingLibraryOverview(externalFilters),
    },
    payloadAction: trainingLibraryDataLoaded,
    shouldShowGlobalLoading: false,
    getResultToKeep: ({ trainingLibrary }) => trainingLibrary.trainingLibraryData.result,
  })
}
